export default __webpack_public_path__ + "static/media/hht2_ep_04.7be493d6.png";